export default __webpack_public_path__ + "static/search_icon-de6971632ee9bc7a2d7ba68425f93d75.webp";